module.exports = __webpack_public_path__ + "img/2024big9.787084f8.png";